import { applyMiddleware, compose, createStore } from 'redux'
import reducer from './reducers'
import thunkMiddleware from 'redux-thunk'
import { load, save } from 'redux-localstorage-simple'

const localStorageSettings = {
  states: ['user', 'preferences'],
  namespace: 'mgd_hotelier',
  namespaceSeparator: '::'
}
const preloadedState = load(localStorageSettings)
const composeEnhancers =
  process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true })
    : compose
const store = createStore(reducer, preloadedState, composeEnhancers(
    applyMiddleware(thunkMiddleware),
    applyMiddleware(save(Object.assign({ debounce: 200, }, localStorageSettings)))
  )
)
export default store
